export const RETRY_FETCH = 'purchases/RETRY_FETCH';
